module.exports = __webpack_public_path__ + "static/profilbild-ff755da6fcbdfc33c9bdff67af3c6af1.png";